/* eslint-disable */
/*eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  FormHelperText,
  CircularProgress,
  Box,
  Avatar
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { PhotoCamera, Delete } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  AddUserTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#009ad8",
    color: "#fff",
    padding: "16px",
    borderRadius: "4px 4px 0 0",
    fontSize: "18px",
    fontWeight: "bold"
  },
  selectField: {
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    border: "1px solid #ccc",
    padding: "10px 12px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc"
      },
      "&:hover fieldset": {
        borderColor: "#999"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#009ad8"
      }
    }
  },
  userTypeField: {
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    border: "1px solid #ccc",
    padding: "10px 12px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc"
      },
      "&:hover fieldset": {
        borderColor: "#999"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#009ad8"
      }
    }
  },
  saveButton: {
    fontWeight: "bold",
    color: "#ffffff",
    backgroundColor: "#009ad8",
    "&:hover": {
      backgroundColor: "#007bb5"
    }
  },
  closeButton: {
    backgroundColor: "#f44336",
    color: "#fff",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#d32f2f"
    },
    "&:disabled": {
      backgroundColor: "#cccccc",
      color: "#666666"
    }
  },
  dialogContent: {
    backgroundColor: "#fafafa",
    padding: "20px",
    maxHeight: "70vh",
    overflowY: "auto"
  },
  formControl: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1)
  },
  textField: {
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    "& .MuiInputBase-input": {
      padding: "12px"
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc"
      },
      "&:hover fieldset": {
        borderColor: "#999"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#009ad8"
      }
    }
  },
  dialogActions: {
    padding: "16px",
    justifyContent: "space-between",
    borderTop: "1px solid #e0e0e0"
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "6px",
    display: "block"
  },
  formHelperText: {
    fontSize: "12px",
    color: "#d32f2f",
    marginLeft: 0
  },
  input: {
    fontSize: "14px",
    padding: "10px 12px"
  },
  inputField: {
    marginBottom: theme.spacing(1.5)
  },
  imageUploadContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    border: "2px dashed #ddd",
    borderRadius: "8px",
    backgroundColor: "#fff"
  },
  avatar: {
    width: 120,
    height: 120,
    marginBottom: theme.spacing(2),
    border: "3px solid #009ad8",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
  },
  uploadButtons: {
    display: "flex",
    gap: theme.spacing(2),
    justifyContent: "center",
    flexWrap: "wrap"
  },
  hiddenInput: {
    display: "none"
  },
  imagePreview: {
    maxWidth: "100%",
    maxHeight: "200px",
    marginTop: theme.spacing(1),
    borderRadius: "4px"
  },
  button: {
    textTransform: "none",
    fontWeight: "bold"
  }
}));

const FormComponent = ({
  data = {},
  columns = [],
  modalType,
  onClose,
  onSubmit
}) => {
  const classes = useStyles();
  const branchManagementReducer = useSelector((state) => state.branchData);
  const usertypesreducer = useSelector((state) => state.usertypes);
  const fileInputRef = useRef(null);

  const [fields, setFields] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [formData, setFormData] = useState({});

  // Safely get data properties with fallbacks
  const safeData = data || {};
  const existingProfileImage = safeData.profileImage;

  useEffect(() => {
    const flattenColumns = (cols) => {
      const flat = [];
      cols.forEach((col) => {
        if (col.id === "TenantDetails") {
          const filteredColumns = col.columns.filter(
            (column) =>
              column.accessorKey !== "userType" &&
              column.accessorKey !== "referralId" &&
              column.accessorKey !== "createdAt"
          );
          flat.push(...filteredColumns);
        } else if (col.columns) {
          flat.push(...flattenColumns(col.columns));
        } else {
          flat.push(col);
        }
      });
      return flat;
    };

    const flattenedColumns = flattenColumns(columns);

    const getNestedValue = (obj, path) => {
      if (!obj || !path) return "";
      return path.split(".").reduce((acc, key) => (acc ? acc[key] : ""), obj);
    };

    const initialFields = flattenedColumns
      .filter(
        (field) =>
          !field.enableHiding &&
          field.accessorKey &&
          field.accessorKey.toLowerCase() !== "username" &&
          field.accessorKey.toLowerCase() !== "id"
      )
      .map((field) => ({
        ...field,
        value:
          modalType === "edit"
            ? getNestedValue(safeData, field.accessorKey) || ""
            : "",
        isEditable: field.enableEditing !== false
      }));

    setFields(initialFields);

    // Initialize formData with existing data
    setFormData(safeData);

    // Set initial image if editing and image exists
    if (modalType === "edit" && existingProfileImage) {
      setImagePreview(existingProfileImage);
    }
  }, [safeData, columns, modalType, existingProfileImage]);

  const handleInputChange = (accessorKey, value) => {
    setFields((prevFields) =>
      prevFields.map((field) =>
        field.accessorKey === accessorKey ? { ...field, value } : field
      )
    );
    
    // Also update the formData
    setFormData(prev => {
      const newData = {...prev};
      const keys = accessorKey.split('.');
      let current = newData;
      
      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) current[keys[i]] = {};
        current = current[keys[i]];
      }
      
      current[keys[keys.length - 1]] = value;
      return newData;
    });
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.match("image.*")) {
        setErrors({ ...errors, profileImage: "Please select an image file" });
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        setErrors({ ...errors, profileImage: "Image must be less than 5MB" });
        return;
      }

      setImageFile(file);
      setErrors({ ...errors, profileImage: "" });

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        const imageDataUrl = e.target.result;
        setImagePreview(imageDataUrl);
        
        // Update formData with the file object
        setFormData(prev => ({...prev, profileImageFile: file}));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setImageFile(null);
    setImagePreview(null);
    setFormData(prev => {
      const newData = {...prev};
      delete newData.profileImageFile;
      delete newData.profileImage;
      return newData;
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const validateForm = () => {
    const newErrors = {};

    fields.forEach((field) => {
      if (field.required && !field.value) {
        newErrors[field.accessorKey] = `${field.header} is required`;
      }

      if (field.accessorKey === "password" && field.value) {
        if (field.value.length < 6) {
          newErrors[field.accessorKey] =
            "Password must be at least 6 characters long";
        }
      }

      if (field.accessorKey === "mobile" && field.value) {
        const phoneRegex = /^\+?[1-9]\d{1,14}$/;
        if (!phoneRegex.test(field.value)) {
          newErrors[field.accessorKey] =
            "Please enter a valid phone number in international format (e.g., +1234567890)";
        }
      }

      if (field.accessorKey === "email" && field.value) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(field.value)) {
          newErrors[field.accessorKey] = "Please enter a valid email address";
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    setLoading(true);

    // Build the final data object to submit
    const updatedData = { ...formData };

    // Add field values to the data
    fields.forEach((field) => {
      if (field.isEditable && field.accessorKey && field.value !== undefined) {
        const setNestedValue = (obj, path, value) => {
          const keys = path.split(".");
          const lastKey = keys.pop();
          const nestedObj = keys.reduce((acc, key) => {
            if (!acc[key]) acc[key] = {};
            return acc[key];
          }, obj);
          nestedObj[lastKey] = value;
        };

        setNestedValue(updatedData, field.accessorKey, field.value);
      }
    });

    // Add the image file if it exists (for upload)
    if (imageFile) {
      updatedData.profileImageFile = imageFile;
    }

    // If we have an existing image URL but no new file, keep the URL
    if (existingProfileImage && !imageFile && !updatedData.profileImage) {
      updatedData.profileImage = existingProfileImage;
    }

    onSubmit(updatedData);
    setLoading(false);
    onClose();
  };

  // Get the current image to display (preview or existing)
  const currentImage = imagePreview || existingProfileImage;

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className={classes.AddUserTitle}>
        {modalType === "edit" ? "Edit User" : "Add User"}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {/* Image Upload Section */}
        <Box className={classes.imageUploadContainer}>
          <Avatar
            src={currentImage}
            className={classes.avatar}
            variant="rounded"
          >
            {!currentImage && "No Image"}
          </Avatar>

          <Box className={classes.uploadButtons}>
            <input
              accept="image/*"
              className={classes.hiddenInput}
              id="profile-image-upload"
              type="file"
              onChange={handleImageUpload}
              ref={fileInputRef}
            />
            <label htmlFor="profile-image-upload">
              <Button
                variant="contained"
                color="primary"
                component="span"
                startIcon={<PhotoCamera />}
                size="small"
                className={classes.button}
              >
                Upload Image
              </Button>
            </label>

            {currentImage && (
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleRemoveImage}
                startIcon={<Delete />}
                size="small"
                className={classes.button}
              >
                Remove Image
              </Button>
            )}
          </Box>

          {errors.profileImage && (
            <FormHelperText error className={classes.formHelperText}>
              {errors.profileImage}
            </FormHelperText>
          )}
        </Box>

        {/* Form Fields */}
        {fields.map((field) => (
          <FormControl
            key={field.accessorKey}
            className={classes.formControl}
            error={Boolean(errors[field.accessorKey])}
            fullWidth
          >
            {field.accessorKey === "userType" ? (
              <>
                <InputLabel className={classes.label}>
                  {field.header}
                </InputLabel>
                <Select
                  value={field.value || ""}
                  onChange={(e) =>
                    handleInputChange(field.accessorKey, e.target.value)
                  }
                  disabled={!field.isEditable}
                  className={classes.inputField}
                >
                  {usertypesreducer?.usertypes &&
                    Object.keys(usertypesreducer.usertypes).map((key) => (
                      <MenuItem
                        key={key}
                        value={usertypesreducer.usertypes[key]}
                      >
                        {usertypesreducer.usertypes[key]}
                      </MenuItem>
                    ))}
                </Select>
              </>
            ) : field.accessorKey === "brokerHomeOffice" ? (
              <>
                <InputLabel className={classes.label}>
                  {field.header}
                </InputLabel>
                <Select
                  value={field.value || ""}
                  onChange={(e) =>
                    handleInputChange(field.accessorKey, e.target.value)
                  }
                  disabled={!field.isEditable}
                  className={classes.inputField}
                >
                  {branchManagementReducer.branches.map((branch) => (
                    <MenuItem key={branch.branchId} value={branch.branchId}>
                      {branch.BranchName}
                    </MenuItem>
                  ))}
                </Select>
              </>
            ) : field.type === "select" ? (
              <>
                <InputLabel className={classes.label}>
                  {field.header}
                </InputLabel>
                <Select
                  value={field.value || ""}
                  onChange={(e) =>
                    handleInputChange(field.accessorKey, e.target.value)
                  }
                  disabled={!field.isEditable}
                  className={classes.inputField}
                >
                  {field.options?.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText className={classes.formHelperText}>
                  {errors[field.accessorKey]}
                </FormHelperText>
              </>
            ) : (
              <TextField
                label={field.header}
                type={field.type || "text"}
                value={field.value || ""}
                disabled={!field.isEditable}
                onChange={(e) =>
                  handleInputChange(field.accessorKey, e.target.value)
                }
                variant="outlined"
                className={classes.textField}
                error={Boolean(errors[field.accessorKey])}
                helperText={errors[field.accessorKey]}
                fullWidth
                InputProps={{
                  className: classes.input
                }}
              />
            )}
          </FormControl>
        ))}
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={onClose}
          className={classes.closeButton}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          className={classes.saveButton}
          disabled={isLoading}
        >
          {isLoading ? <CircularProgress size={20} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FormComponent;